import { SearchOffersDto } from '@wwt/entities/api/search-response'

import { SearchRequestParams } from '@/entities/search'
import { assert } from '@/shared/lib/assert'

import { objectToFlatObject } from '../objectToFlatObject'
import { notNestedObjectReplaceDatesWithStrings } from '../replaceDatesWithStrings'

export const searchRequestToUrlSearchParams = (
	searchRequest: SearchRequestParams
): URLSearchParams => {
	// TODO: Remove structuredClone
	// eslint-disable-next-line
	const searchRequestCopy = structuredClone(searchRequest)

	const dataForRemoveDates = objectToFlatObject(searchRequestCopy)

	assert(
		dataForRemoveDates !== null,
		'Search request data after object to float is null'
	)

	const urlParams = notNestedObjectReplaceDatesWithStrings(
		dataForRemoveDates
	) as Record<string, string>

	assert(
		Boolean(urlParams),
		'Error on transform searchRequest data to urlParams'
	)

	return new URLSearchParams(urlParams)
}

export const searchOffersToUrlSearchParams = (
	searchRequest: SearchOffersDto
): URLSearchParams => {
	// TODO: Remove structuredClone
	// eslint-disable-next-line
	const searchRequestCopy = structuredClone(searchRequest)

	const dataForRemoveDates = objectToFlatObject(searchRequestCopy)

	assert(
		dataForRemoveDates !== null,
		'Search request data after object to float is null'
	)

	const urlParams = notNestedObjectReplaceDatesWithStrings(
		dataForRemoveDates
	) as Record<string, string>

	assert(
		Boolean(urlParams),
		'Error on transform searchRequest data to urlParams'
	)

	return new URLSearchParams(urlParams)
}
